import OtherPairing from './OtherPairing';

export default OtherPairing;
